/**
 * タグ管理画面のタグクラス
 *
 * @export TagInfo
 * @class TagInfo
 */
export class TagInfo {
  public check = false;
  constructor(public tagId: string, public tagName: string) {}
}
